import React, { Component } from "react";

import CollapsibleMenu from "../../CollapsibleMenu";

import data from "../../data/capacity";

import colors from "../../colors";

import Slider from "./Slider";

import ReactHtmlParser from "react-html-parser";
export default class TRTechnicalProposal extends Component {
  render() {
    return (
      <div
        className="ui raised segment"
        style={{
          marginTop: "0em",
          padding: "0px",
          marginLeft: "20%",
          marginRight: "20%",
        }}
      >
        <div
          style={{
            paddingTop: "0px",
            paddingRight: "10px",
            paddingBottom: "10px",
            paddingLeft: "10px",
            backgroundColor: colors.background,
          }}
        >
          <Slider />
          <main style={{ flexGrow: "1", overflowX: "auto" }}>
            <div className="card" style={{ width: "100%", height: "500px" }}>
              {/* <main style={{flexGrow: "1", width:"100%", height:"500px", flexGrow:1, flexBasis:"content", alignSelf:"bsaeline"}}>
          <div className="card"> */}
              {/* flexGrow:1, width:"25%", flexBasis:"content", alignSelf:"bsaeline", padding:"10px" */}
              <div
                className="card-body"
                style={{ overflowY: "auto", height: "100%" }}
              >
                <h3 align="center" style={{ color: "#002171" }}>
                  Capacity Building{" "}
                </h3>
                <hr />
                <h5 align="center" style={{ color: "#002171" }}>
                  Technical Proposal
                </h5>

                {Object.keys(data).map((key) => (
                  <CollapsibleMenu
                    style={{ textAlign: "center" }}
                    key={key}
                    title={key}
                    content={ReactHtmlParser(data[key]["content"])}
                  />
                ))}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}
